import { render } from "./FollowupReport.vue?vue&type=template&id=02a051ab&scoped=true"
import script from "./FollowupReport.vue?vue&type=script&lang=js"
export * from "./FollowupReport.vue?vue&type=script&lang=js"

import "./FollowupReport.vue?vue&type=style&index=0&id=02a051ab&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Leads\\leads-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02a051ab"]])

export default __exports__